import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import EditProductLogoModal from '../../Modals/EditProductLogoModal/EditProductLogoModal'
import { IProductLogo } from '../../../infrastructure/interfaces'
import { updateProductLogo } from '../../../actions/imageActions';
import HeaderBar from '../../HeaderBar/HeaderBar';
import { contentImagesRelativePath } from '../../../constants';
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import {archiveProductLogo} from '../../../actions/actions'

export interface IManageProductLogosProps {
  productLogosList: [IProductLogo];
  updateProductLogo(formData: FormData): void;
  archiveProductLogo(logo: IProductLogo): void;
}

export interface IManageProductLogosState {
    showEditModal: boolean;
    showArchiveLogoModal: boolean;
    selectedLogo?: IProductLogo;
}

const mapStateToProps = (state: any) => {
  return {
    productLogosList: state.productLogosList,
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
    updateProductLogo: (formData: FormData) => {
      dispatch(updateProductLogo(formData));
    },
    archiveProductLogo: (logo: IProductLogo) => {
      dispatch(archiveProductLogo(logo));
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ProductsTable extends React.Component<IManageProductLogosProps, IManageProductLogosState> {
  tableRow: HTMLElement;
  constructor(props: IManageProductLogosProps) {
    super(props);
    this.state = {
      showEditModal: false,
      showArchiveLogoModal: false,
    };
  }

  onEditProductLogo = (productLogo: IProductLogo) => {
      this.setState({
          showEditModal: true,
          showArchiveLogoModal: false,
          selectedLogo: productLogo
      });
  }

  onArchiveRequest(productLogo: IProductLogo) {
    this.setState({
        showEditModal: false,
        showArchiveLogoModal: true,
        selectedLogo: productLogo
    });
  }

  archiveProductLogo(logo: IProductLogo) {
    this.props.archiveProductLogo(logo);
  }

  closeModals() {
    this.setState({
      showEditModal: false,
      showArchiveLogoModal: false,
    });
  }

  render() {
    const {
      productLogosList,
    } = this.props;

    return (

      <div className="root-container">
      <HeaderBar />
      <div className="inner-su-container">
        <div className="manage-items-row">
          <div className="in-row-text-container">
            Manage Product Logos
          </div>
        </div>
        <table className="table-scrollableSU documents-table">
          <thead style={{ paddingRight: getScrollbarWidth() }}>
            <tr>
              <th>Product</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="document-table-body">
            {productLogosList.map((p: IProductLogo) =>
              <tr key={p.src} ref={tr => this.tableRow = tr!}>
                <td dangerouslySetInnerHTML={{__html:p.id}} />
                <td>
                  <img className="inlineImagesTableImage" src={contentImagesRelativePath + p.src} />
                </td>
                <td>
                  <div className="button-wrapper">
                    <button
                      className="btn primary-blue"
                      onClick={() => this.onEditProductLogo(p)}
                      title={TooltipCont.EDIT}
                      disabled={false}
                    >
                      Edit
                    </button>
                    <button
                      className="btn primary-red"
                      onClick={() => this.onArchiveRequest(p)}
                      title={TooltipCont.ARCHIVE}
                      disabled={false}
                    >
                      Archive
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>

        <EditProductLogoModal
            show={this.state.showEditModal}
            onClose={() => this.closeModals()}
            productLogo={this.state.selectedLogo}
            updateProductLogo={this.props.updateProductLogo}
        />

        <DeleteConfirmModal
              show={this.state.showArchiveLogoModal}
              onClose={() => this.closeModals()}
              onSave={() => {
                  if(this.state.selectedLogo) {
                    this.archiveProductLogo(this.state.selectedLogo);
                  }
                  this.closeModals();
              }}
              title='Are you sure you want to archive this logo?'
          />
      </div>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageProductLogos.tsx